import React, { useState } from 'react'
import './register.css'
import {
  FaChevronRight as ChevronRight,
  FaChevronDown as ChevronDown,
  FaChevronUp as ChevronUp,
  FaCalendarAlt as Calendar,
  FaMapMarkerAlt as MapPin,
  FaTimes as X,
} from 'react-icons/fa'
import { useRegistration } from '../../../../context/RegistrationContext'
import { CouponValidation } from '../../../../api/Webservices'

const OrderSummary = ({
  selectedTickets,
  attendeeData,
  buyerData,
  eventData,
  eventConfig,
  onBack,
  onProceedToPayment,
  onEditAttendee,
}) => {
  console.log('OrderSummary Props:',eventData.is_coupon
  )
  console.log(
    selectedTickets[0] && selectedTickets[0].currency,
    'selectedTickets[0] && selectedTickets[0].currency'
  )
  const { updateRegistrationData, clearRegistrationData, registrationData } =
    useRegistration()
  const [expandedTickets, setExpandedTickets] = useState({})
  const [showTaxBreakdown, setShowTaxBreakdown] = useState(false)
  const [couponCode, setCouponCode] = useState('')
  const [couponApplied, setCouponApplied] = useState(false)
  const [couponDiscount, setCouponDiscount] = useState(0)
  const [couponError, setCouponError] = useState('')
  const [isCouponLoading, setIsCouponLoading] = useState(false)
  const stateIsSame = eventData?.state_is_same === 'yes'
  const toggleTicketExpansion = (ticketId) => {
    setExpandedTickets((prev) => ({
      ...prev,
      [ticketId]: !prev[ticketId],
    }))
  }
  const isCouponAvailable = eventData?.is_coupon === 1 ? true : false

  const handleApplyCoupon = async () => {
    if (!couponCode) {
      setCouponError('Please enter a coupon code')
      setCouponDiscount(0)
      setCouponApplied(false)
      return
    }

    setIsCouponLoading(true)
    setCouponError('')

    const payload = {
      event_id: localStorage.getItem('eventId'),
      coupen: couponCode,
      user_id: registrationData.attendees_payments_id,
    }

    try {
      const res = await CouponValidation(payload)
      const { discount, discount_type, coupon_code } = res.data

      if (discount_type === 'percentage') {
        setCouponDiscount(Number(discount))
        setCouponApplied(true)
        setCouponError('')
      } else {
        setCouponError('Invalid coupon type or discount value')
        setCouponDiscount(0)
        setCouponApplied(false)
      }
    } catch (err) {
      console.error('Coupon validation error:', err)
      const errorMessage =
        err.response?.data?.message ||
        'Failed to validate coupon. Please try again.'
      setCouponError(errorMessage)
      setCouponDiscount(0)
      setCouponApplied(false)
    } finally {
      setIsCouponLoading(false)
    }
  }

  const getAddonBaseAndQty = (addon) => {
    if (
      addon.addons_type !== 'variant' ||
      !addon.selectedVariants ||
      addon.selectedVariants.length === 0
    ) {
      return {
        base: Number(addon.price) || 0,
        qty: addon.quantity || 0,
        isVariant: false,
      }
    }

    // For variants, sum over selected variants
    let totalBase = 0
    let totalQty = 0
    addon.selectedVariants.forEach((variant) => {
      if (variant.quantity > 0) {
        totalBase += (Number(variant.variant_price) || 0) * variant.quantity
        totalQty += variant.quantity
      }
    })

    return {
      base: totalBase,
      qty: totalQty,
      isVariant: true,
    }
  }

const calculatePricing = () => {
    const roundMoney = (value) => Math.round(value * 100) / 100; 
    let subtotal = 0
    let tax_breakdown = []
    let total_tax = 0

    selectedTickets.forEach((ticket) => {
      const base = Number(ticket.price) || 0
      const qty = ticket.ticketQuantity || 1
      let tax_options = ticket.tax_options || []
      if (typeof tax_options === 'string') {
        try {
          tax_options = JSON.parse(tax_options)
        } catch {
          tax_options = []
        }
      }
      const relevantTaxes = stateIsSame
        ? tax_options.filter((t) => ['CGST', 'SGST'].includes(t.tax_name))
        : tax_options.filter((t) => t.tax_name === 'IGST')
      let item_net = 0
      let item_taxes = []

 
      if (ticket.category === 'Free' || ticket.tax_type === 'No Tax') {
        item_net = roundMoney(base * qty)
        item_taxes = relevantTaxes.map((t) => ({
          tax_name: t.tax_name,
          tax_percentage: Number.parseFloat(t.tax_percentage) || 0,
          tax_amount: 0,
        }))
      } else if (ticket.tax_type === 'Including Tax') {
        const item_total = roundMoney(base * qty)
        item_taxes = relevantTaxes.map((t) => {
          const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
          const frac =
            tax_percentage /
            100 /
            (1 +
              relevantTaxes.reduce(
                (sum, tx) => sum + (Number.parseFloat(tx.tax_percentage) || 0),
                0
              ) /
                100)
          const tax_amount = roundMoney(item_total * frac)
          return {
            tax_name: t.tax_name,
            tax_percentage,
            tax_amount,
          }
        })
        const item_tax_total = item_taxes.reduce(
          (sum, tx) => sum + tx.tax_amount,
          0
        )
        item_net = roundMoney(item_total - item_tax_total)
      } else if (ticket.tax_type === 'Excluding Tax') {
        item_net = roundMoney(base * qty)
        item_taxes = relevantTaxes.map((t) => {
          const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
          const tax_amount = roundMoney(item_net * (tax_percentage / 100))
          return {
            tax_name: t.tax_name,
            tax_percentage,
            tax_amount,
          }
        })
      }

      subtotal += item_net
      total_tax += item_taxes.reduce((sum, t) => sum + t.tax_amount, 0)
      tax_breakdown.push({
        name: `${qty} x ${ticket.title} (Main Ticket)`,
        base_price: item_net,
        taxes: item_taxes,
      })

      const ticketAttendeeData = attendeeData.tickets
        ? attendeeData.tickets.find(
            (data) => data.ticket_id.toString() === ticket.id.toString()
          )
        : null
      if (ticketAttendeeData) {
        ticketAttendeeData.attendee_data.forEach((attendee) => {
          let add_ons_data = attendee.add_ons_data || attendee.add_ons || []
          if (typeof add_ons_data === 'string') {
            try {
              add_ons_data = JSON.parse(add_ons_data)
            } catch {
              add_ons_data = []
            }
          }
    
          const variantAddons = {}
          add_ons_data.forEach((addon) => {
            if (!variantAddons[addon.id]) {
              variantAddons[addon.id] = {
                ...addon,
                totalBase: 0,
                totalQty: 0,
                variantNames: [],
              }
            }
            if (addon.addons_type === 'variant' && addon.selectedVariants) {
              addon.selectedVariants.forEach((v) => {
                if (v.quantity > 0) {
                  variantAddons[addon.id].totalBase +=
                    (Number(v.variant_price) || 0) * v.quantity
                  variantAddons[addon.id].totalQty += v.quantity
                  if (
                    !variantAddons[addon.id].variantNames.includes(
                      v.variant_name
                    )
                  ) {
                    variantAddons[addon.id].variantNames.push(v.variant_name)
                  }
                }
              })
            } else {
              variantAddons[addon.id].totalBase +=
                (Number(addon.price) || 0) * (addon.quantity || 0)
              variantAddons[addon.id].totalQty += addon.quantity || 0
            }
          })

          Object.values(variantAddons).forEach((addon) => {
            if (addon.isAdded && addon.addon_status === 'onsale') {
              const a_gross = addon.totalBase
              const a_qty = addon.totalQty
              if (a_gross === 0) return
              let a_tax_options = addon.tax_options || []
              if (typeof a_tax_options === 'string') {
                try {
                  a_tax_options = JSON.parse(a_tax_options)
                } catch {
                  a_tax_options = []
                }
              }
              const a_relevantTaxes = stateIsSame
                ? a_tax_options.filter((t) =>
                    ['CGST', 'SGST'].includes(t.tax_name)
                  )
                : a_tax_options.filter((t) => t.tax_name === 'IGST')
              const a_rate =
                a_relevantTaxes.reduce(
                  (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                  0
                ) / 100
              let a_net = 0
              let a_taxes = []

  
              if (addon.tax_type === 'No Tax') {
                a_net = roundMoney(a_gross)
                a_taxes = a_relevantTaxes.map((t) => ({
                  tax_name: t.tax_name,
                  tax_percentage: Number.parseFloat(t.tax_percentage) || 0,
                  tax_amount: 0,
                }))
              } else if (addon.tax_type === 'Including Tax') {
                const a_total = roundMoney(a_gross)
                a_taxes = a_relevantTaxes.map((t) => {
                  const tax_percentage =
                    Number.parseFloat(t.tax_percentage) || 0
                  const frac = tax_percentage / 100 / (1 + a_rate)
                  const tax_amount = roundMoney(a_total * frac)
                  return {
                    tax_name: t.tax_name,
                    tax_percentage,
                    tax_amount,
                  }
                })
                const a_tax_total = a_taxes.reduce(
                  (sum, tx) => sum + tx.tax_amount,
                  0
                )
                a_net = roundMoney(a_total - a_tax_total)
              } else {

                a_net = roundMoney(a_gross)
                a_taxes = a_relevantTaxes.map((t) => {
                  const tax_percentage =
                    Number.parseFloat(t.tax_percentage) || 0
                  const tax_amount = roundMoney(a_net * (tax_percentage / 100))
                  return {
                    tax_name: t.tax_name,
                    tax_percentage,
                    tax_amount,
                  }
                })
              }

              subtotal += a_net
              total_tax += a_taxes.reduce((sum, t) => sum + t.tax_amount, 0)
              const variantNamesStr =
                addon.variantNames.length > 0
                  ? ` (${addon.variantNames.join(', ')})`
                  : ''
              const addonName = `${addon.add_on_name}${variantNamesStr}`
              tax_breakdown.push({
                name: `${a_qty} x ${addonName} (Addon)`,
                base_price: a_net,
                taxes: a_taxes,
              })
            }
          })

          const guestData = attendee.guest_data || []
          guestData.forEach((guest, guestIndex) => {
            const g_base = Number(ticket.guestPrice) || 0
            let g_tax_options = ticket.guest_details?.tax_options || []
            if (typeof g_tax_options === 'string') {
              try {
                g_tax_options = JSON.parse(g_tax_options)
              } catch {
                g_tax_options = []
              }
            }
            const g_relevantTaxes = stateIsSame
              ? g_tax_options.filter((t) =>
                  ['CGST', 'SGST'].includes(t.tax_name)
                )
              : g_tax_options.filter((t) => t.tax_name === 'IGST')
            const g_rate =
              g_relevantTaxes.reduce(
                (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                0
              ) / 100
            const g_tax_type = ticket.guest_details?.tax_type || 'No Tax'
            let g_net = 0
            let g_taxes = []


            if (g_tax_type === 'No Tax') {
              g_net = roundMoney(g_base)
              g_taxes = g_relevantTaxes.map((t) => ({
                tax_name: t.tax_name,
                tax_percentage: Number.parseFloat(t.tax_percentage) || 0,
                tax_amount: 0,
              }))
            } else if (g_tax_type === 'Including Tax') {
              const g_total = roundMoney(g_base)
              g_taxes = g_relevantTaxes.map((t) => {
                const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
                const frac = tax_percentage / 100 / (1 + g_rate)
                const tax_amount = roundMoney(g_total * frac)
                return {
                  tax_name: t.tax_name,
                  tax_percentage,
                  tax_amount,
                }
              })
              const g_tax_total = g_taxes.reduce(
                (sum, tx) => sum + tx.tax_amount,
                0
              )
              g_net = roundMoney(g_total - g_tax_total)
            } else if (g_tax_type === 'Excluding Tax') {
              g_net = roundMoney(g_base)
              g_taxes = g_relevantTaxes.map((t) => {
                const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
                const tax_amount = roundMoney(g_net * (tax_percentage / 100))
                return {
                  tax_name: t.tax_name,
                  tax_percentage,
                  tax_amount,
                }
              })
            }

            subtotal += g_net
            total_tax += g_taxes.reduce((sum, t) => sum + t.tax_amount, 0)
            tax_breakdown.push({
              name: `1 x Accompanying Person (${ticket.title}) - Guest ${
                guestIndex + 1
              } (Guest)`,
              base_price: g_net,
              taxes: g_taxes,
            })

            let guest_add_ons = guest.add_ons || []
            if (typeof guest_add_ons === 'string') {
              try {
                guest_add_ons = JSON.parse(guest_add_ons)
              } catch {
                guest_add_ons = []
              }
            }

            const guestVariantAddons = {}
            guest_add_ons.forEach((addon) => {
              if (!guestVariantAddons[addon.id]) {
                guestVariantAddons[addon.id] = {
                  ...addon,
                  totalBase: 0,
                  totalQty: 0,
                  variantNames: [],
                }
              }
              if (addon.addons_type === 'variant' && addon.selectedVariants) {
                addon.selectedVariants.forEach((v) => {
                  if (v.quantity > 0) {
                    guestVariantAddons[addon.id].totalBase +=
                      (Number(v.variant_price) || 0) * v.quantity
                    guestVariantAddons[addon.id].totalQty += v.quantity
                    if (
                      !guestVariantAddons[addon.id].variantNames.includes(
                        v.variant_name
                      )
                    ) {
                      guestVariantAddons[addon.id].variantNames.push(
                        v.variant_name
                      )
                    }
                  }
                })
              } else {
                guestVariantAddons[addon.id].totalBase +=
                  (Number(addon.price) || 0) * (addon.quantity || 0)
                guestVariantAddons[addon.id].totalQty += addon.quantity || 0
              }
            })

            Object.values(guestVariantAddons).forEach((addon) => {
              if (addon.isAdded && addon.addon_status === 'onsale') {
                const a_gross = addon.totalBase
                const a_qty = addon.totalQty
                if (a_gross === 0) return
                let a_tax_options = addon.tax_options || []
                if (typeof a_tax_options === 'string') {
                  try {
                    a_tax_options = JSON.parse(a_tax_options)
                  } catch {
                    a_tax_options = []
                  }
                }
                const a_relevantTaxes = stateIsSame
                  ? a_tax_options.filter((t) =>
                      ['CGST', 'SGST'].includes(t.tax_name)
                    )
                  : a_tax_options.filter((t) => t.tax_name === 'IGST')
                const a_rate =
                  a_relevantTaxes.reduce(
                    (sum, t) =>
                      sum + (Number.parseFloat(t.tax_percentage) || 0),
                    0
                  ) / 100
                let a_net = 0
                let a_taxes = []

               
                if (addon.tax_type === 'No Tax') {
                  a_net = roundMoney(a_gross)
                  a_taxes = a_relevantTaxes.map((t) => ({
                    tax_name: t.tax_name,
                    tax_percentage: Number.parseFloat(t.tax_percentage) || 0,
                    tax_amount: 0,
                  }))
                } else if (addon.tax_type === 'Including Tax') {
                  const a_total = roundMoney(a_gross)
                  a_taxes = a_relevantTaxes.map((t) => {
                    const tax_percentage =
                      Number.parseFloat(t.tax_percentage) || 0
                    const frac = tax_percentage / 100 / (1 + a_rate)
                    const tax_amount = roundMoney(a_total * frac)
                    return {
                      tax_name: t.tax_name,
                      tax_percentage,
                      tax_amount,
                    }
                  })
                  const a_tax_total = a_taxes.reduce(
                    (sum, tx) => sum + tx.tax_amount,
                    0
                  )
                  a_net = roundMoney(a_total - a_tax_total)
                } else {
         
                  a_net = roundMoney(a_gross)
                  a_taxes = a_relevantTaxes.map((t) => {
                    const tax_percentage =
                      Number.parseFloat(t.tax_percentage) || 0
                    const tax_amount = roundMoney(a_net * (tax_percentage / 100))
                    return {
                      tax_name: t.tax_name,
                      tax_percentage,
                      tax_amount,
                    }
                  })
                }

                subtotal += a_net
                total_tax += a_taxes.reduce((sum, t) => sum + t.tax_amount, 0)
                const variantNamesStr =
                  addon.variantNames.length > 0
                    ? ` (${addon.variantNames.join(', ')})`
                    : ''
                const addonName = `${addon.add_on_name}${variantNamesStr}`
                tax_breakdown.push({
                  name: `${a_qty} x ${addonName} (Guest) (Addon)`,
                  base_price: a_net,
                  taxes: a_taxes,
                })
              }
            })
          })
        })
      }
    })


    const tax = roundMoney(total_tax)
    const subtotalRounded = roundMoney(subtotal)
    const discount = couponApplied
      ? roundMoney((subtotalRounded * couponDiscount) / 100)
      : 0
    const total = roundMoney(subtotalRounded + tax - discount)

    const taxName = eventConfig?.tax_name || 'SGST'

    return {
      subtotal: subtotalRounded,
      tax,
      total,
      discount,
      taxName,
      tax_breakdown,
    }
  }

const getTaxBreakdownItems = () => {
    const roundMoney = (value) => Math.round(value * 100) / 100; 
    const items = []

    selectedTickets.forEach((ticket) => {
      const ticketQuantity = ticket.ticketQuantity || 1
      const ticketPrice = Number(ticket.price) || 0
      let tax_options = ticket.tax_options || []
      if (typeof tax_options === 'string') {
        try {
          tax_options = JSON.parse(tax_options)
        } catch {
          tax_options = []
        }
      }
      const relevantTaxes = stateIsSame
        ? tax_options.filter((t) => ['CGST', 'SGST'].includes(t.tax_name))
        : tax_options.filter((t) => t.tax_name === 'IGST')
      const rate =
        relevantTaxes.reduce(
          (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
          0
        ) / 100

      let itemTotal = roundMoney(ticketPrice * ticketQuantity)
      let itemNet = 0
      let itemTax = 0

      if (ticket.category === 'Free' || ticket.tax_type === 'No Tax') {
        itemTax = 0
        itemNet = roundMoney(ticketPrice * ticketQuantity)
      } else if (ticket.tax_type === 'Including Tax') {
        let item_taxes = relevantTaxes.map((t) => {
          const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
          const frac = tax_percentage / 100 / (1 + rate)
          const tax_amount = roundMoney(itemTotal * frac)
          return tax_amount
        })
        itemTax = item_taxes.reduce((sum, amt) => sum + amt, 0)
        itemNet = roundMoney(itemTotal - itemTax)
      } else if (ticket.tax_type === 'Excluding Tax') {
        itemNet = roundMoney(ticketPrice * ticketQuantity)
        itemTax = roundMoney(itemNet * rate)
      }

      items.push({
        name: `${ticketQuantity} x ${ticket.title} (Main Ticket)`,
        basePrice: itemNet,
        tax: itemTax,
        totalPrice: roundMoney(itemNet + itemTax),
      })

      const ticketAttendeeData = attendeeData.tickets
        ? attendeeData.tickets.find(
            (data) => data.ticket_id.toString() === ticket.id.toString()
          )
        : null
      if (ticketAttendeeData) {
        ticketAttendeeData.attendee_data.forEach((attendee) => {
          let add_ons_data = attendee.add_ons_data || attendee.add_ons || []
          if (typeof add_ons_data === 'string') {
            try {
              add_ons_data = JSON.parse(add_ons_data)
            } catch {
              add_ons_data = []
            }
          }
        
          const variantAddons = {}
          add_ons_data.forEach((addon) => {
            if (!variantAddons[addon.id]) {
              variantAddons[addon.id] = {
                ...addon,
                totalBase: 0,
                totalQty: 0,
                variantNames: [],
              }
            }
            if (addon.addons_type === 'variant' && addon.selectedVariants) {
              addon.selectedVariants.forEach((v) => {
                if (v.quantity > 0) {
                  variantAddons[addon.id].totalBase +=
                    (Number(v.variant_price) || 0) * v.quantity
                  variantAddons[addon.id].totalQty += v.quantity
                  if (
                    !variantAddons[addon.id].variantNames.includes(
                      v.variant_name
                    )
                  ) {
                    variantAddons[addon.id].variantNames.push(v.variant_name)
                  }
                }
              })
            } else {
              variantAddons[addon.id].totalBase +=
                (Number(addon.price) || 0) * (addon.quantity || 0)
              variantAddons[addon.id].totalQty += addon.quantity || 0
            }
          })

          Object.values(variantAddons).forEach((addon) => {
            if (addon.isAdded && addon.addon_status === 'onsale') {
              const a_gross = addon.totalBase
              const a_qty = addon.totalQty
              if (a_gross === 0) return
              let a_tax_options = addon.tax_options || []
              if (typeof a_tax_options === 'string') {
                try {
                  a_tax_options = JSON.parse(a_tax_options)
                } catch {
                  a_tax_options = []
                }
              }
              const a_relevantTaxes = stateIsSame
                ? a_tax_options.filter((t) =>
                    ['CGST', 'SGST'].includes(t.tax_name)
                  )
                : a_tax_options.filter((t) => t.tax_name === 'IGST')
              const a_rate =
                a_relevantTaxes.reduce(
                  (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                  0
                ) / 100
              const a_tax_type = addon.tax_type || 'No Tax'
              let a_net = 0
              let a_tax = 0

      
              if (a_tax_type === 'No Tax') {
                a_net = roundMoney(a_gross)
                a_tax = 0
              } else if (a_tax_type === 'Including Tax') {
                const a_total = roundMoney(a_gross)
                let a_taxes = a_relevantTaxes.map((t) => {
                  const tax_percentage =
                    Number.parseFloat(t.tax_percentage) || 0
                  const frac = tax_percentage / 100 / (1 + a_rate)
                  const tax_amount = roundMoney(a_total * frac)
                  return tax_amount
                })
                a_tax = a_taxes.reduce((sum, amt) => sum + amt, 0)
                a_net = roundMoney(a_total - a_tax)
              } else if (a_tax_type === 'Excluding Tax') {
                a_net = roundMoney(a_gross)
                a_tax = roundMoney(a_net * a_rate)
              }

              const variantNamesStr =
                addon.variantNames.length > 0
                  ? ` (${addon.variantNames.join(', ')})`
                  : ''
              const addonDisplayName = `${addon.add_on_name}${variantNamesStr}`

              items.push({
                name: `${a_qty} x ${addonDisplayName} (Addon)`,
                basePrice: a_net,
                tax: a_tax,
                totalPrice: roundMoney(a_net + a_tax),
              })
            }
          })

          const guestData = attendee.guest_data || []
          guestData.forEach((guest, guestIndex) => {
            const g_base = Number(ticket.guestPrice) || 0
            let g_tax_options = ticket.guest_details?.tax_options || []
            if (typeof g_tax_options === 'string') {
              try {
                g_tax_options = JSON.parse(g_tax_options)
              } catch {
                g_tax_options = []
              }
            }
            const g_relevantTaxes = stateIsSame
              ? g_tax_options.filter((t) =>
                  ['CGST', 'SGST'].includes(t.tax_name)
                )
              : g_tax_options.filter((t) => t.tax_name === 'IGST')
            const g_rate =
              g_relevantTaxes.reduce(
                (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                0
              ) / 100
            const g_tax_type = ticket.guest_details?.tax_type || 'No Tax'
            let g_net = 0
            let g_tax = 0

            if (g_tax_type === 'No Tax') {
              g_net = roundMoney(g_base)
              g_tax = 0
            } else if (g_tax_type === 'Including Tax') {
              const g_total = roundMoney(g_base)
              let g_taxes = g_relevantTaxes.map((t) => {
                const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
                const frac = tax_percentage / 100 / (1 + g_rate)
                const tax_amount = roundMoney(g_total * frac)
                return tax_amount
              })
              g_tax = g_taxes.reduce((sum, amt) => sum + amt, 0)
              g_net = roundMoney(g_total - g_tax)
            } else if (g_tax_type === 'Excluding Tax') {
              g_net = roundMoney(g_base)
              g_tax = roundMoney(g_net * g_rate)
            }

            items.push({
              name: `1 x Accompanying Person (${ticket.title}) - Guest ${
                guestIndex + 1
              } (Guest)`,
              basePrice: g_net,
              tax: g_tax,
              totalPrice: roundMoney(g_net + g_tax),
            })

            let guest_add_ons = guest.add_ons || []
            if (typeof guest_add_ons === 'string') {
              try {
                guest_add_ons = JSON.parse(guest_add_ons)
              } catch {
                guest_add_ons = []
              }
            }

            const guestVariantAddons = {}
            guest_add_ons.forEach((addon) => {
              if (!guestVariantAddons[addon.id]) {
                guestVariantAddons[addon.id] = {
                  ...addon,
                  totalBase: 0,
                  totalQty: 0,
                  variantNames: [],
                }
              }
              if (addon.addons_type === 'variant' && addon.selectedVariants) {
                addon.selectedVariants.forEach((v) => {
                  if (v.quantity > 0) {
                    guestVariantAddons[addon.id].totalBase +=
                      (Number(v.variant_price) || 0) * v.quantity
                    guestVariantAddons[addon.id].totalQty += v.quantity
                    if (
                      !guestVariantAddons[addon.id].variantNames.includes(
                        v.variant_name
                      )
                    ) {
                      guestVariantAddons[addon.id].variantNames.push(
                        v.variant_name
                      )
                    }
                  }
                })
              } else {
                guestVariantAddons[addon.id].totalBase +=
                  (Number(addon.price) || 0) * (addon.quantity || 0)
                guestVariantAddons[addon.id].totalQty += addon.quantity || 0
              }
            })

            Object.values(guestVariantAddons).forEach((addon) => {
              if (addon.isAdded && addon.addon_status === 'onsale') {
                const a_gross = addon.totalBase
                const a_qty = addon.totalQty
                if (a_gross === 0) return
                let a_tax_options = addon.tax_options || []
                if (typeof a_tax_options === 'string') {
                  try {
                    a_tax_options = JSON.parse(a_tax_options)
                  } catch {
                    a_tax_options = []
                  }
                }
                const a_relevantTaxes = stateIsSame
                  ? a_tax_options.filter((t) =>
                      ['CGST', 'SGST'].includes(t.tax_name)
                    )
                  : a_tax_options.filter((t) => t.tax_name === 'IGST')
                const a_rate =
                  a_relevantTaxes.reduce(
                    (sum, t) =>
                      sum + (Number.parseFloat(t.tax_percentage) || 0),
                    0
                  ) / 100
                const a_tax_type = addon.tax_type || 'No Tax'
                let a_net = 0
                let a_tax = 0


                if (a_tax_type === 'No Tax') {
                  a_net = roundMoney(a_gross)
                  a_tax = 0
                } else if (a_tax_type === 'Including Tax') {
                  const a_total = roundMoney(a_gross)
                  let a_taxes = a_relevantTaxes.map((t) => {
                    const tax_percentage =
                      Number.parseFloat(t.tax_percentage) || 0
                    const frac = tax_percentage / 100 / (1 + a_rate)
                    const tax_amount = roundMoney(a_total * frac)
                    return tax_amount
                  })
                  a_tax = a_taxes.reduce((sum, amt) => sum + amt, 0)
                  a_net = roundMoney(a_total - a_tax)
                } else if (a_tax_type === 'Excluding Tax') {
                  a_net = roundMoney(a_gross)
                  a_tax = roundMoney(a_net * a_rate)
                }

                const variantNamesStr =
                  addon.variantNames.length > 0
                    ? ` (${addon.variantNames.join(', ')})`
                    : ''
                const addonDisplayName = `${addon.add_on_name}${variantNamesStr}`

                items.push({
                  name: `${a_qty} x ${addonDisplayName} (Guest) (Addon)`,
                  basePrice: a_net,
                  tax: a_tax,
                  totalPrice: roundMoney(a_net + a_tax),
                })
              }
            })
          })
        })
      }
    })

    return items
  }

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }

  const preparePaymentData = () => {
    const pricingData = calculatePricing()
    let totalTicketAmount = 0
    let totalGuestAmount = 0
    let totalAddonsAmount = 0

    selectedTickets.forEach((ticket) => {
      const ticketPrice = Number(ticket.price) || 0
      const ticketQuantity = ticket.ticketQuantity || 1
      let tax_options = ticket.tax_options || []
      if (typeof tax_options === 'string') {
        try {
          tax_options = JSON.parse(tax_options)
        } catch {
          tax_options = []
        }
      }
      const relevantTaxes = stateIsSame
        ? tax_options.filter((t) => ['CGST', 'SGST'].includes(t.tax_name))
        : tax_options.filter((t) => t.tax_name === 'IGST')
      const rate =
        relevantTaxes.reduce(
          (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
          0
        ) / 100

      let ticketBase = Math.round(ticketPrice * ticketQuantity)
      let ticket_tax = 0
      if (ticket.tax_type === 'Including Tax' && ticket.category !== 'Free') {
        let item_taxes = relevantTaxes.map((t) => {
          const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
          const frac = tax_percentage / 100 / (1 + rate)
          const tax_amount = Math.round(ticketBase * frac)
          return tax_amount
        })
        ticket_tax = item_taxes.reduce((sum, amt) => sum + amt, 0)
        ticketBase = ticketBase - ticket_tax
      }
      totalTicketAmount += ticketBase

      const ticketAttendeeData = attendeeData.tickets
        ? attendeeData.tickets.find(
            (data) => data.ticket_id.toString() === ticket.id.toString()
          )
        : null
      if (ticketAttendeeData) {
        ticketAttendeeData.attendee_data.forEach((attendee) => {
          let add_ons_data = attendee.add_ons_data || attendee.add_ons || []
          if (typeof add_ons_data === 'string') {
            try {
              add_ons_data = JSON.parse(add_ons_data)
            } catch {
              add_ons_data = []
            }
          }
          // Group for variants
          const variantAddons = {}
          add_ons_data.forEach((addon) => {
            if (!variantAddons[addon.id]) {
              variantAddons[addon.id] = { ...addon, totalBase: 0, totalQty: 0 }
            }
            if (addon.addons_type === 'variant' && addon.selectedVariants) {
              addon.selectedVariants.forEach((v) => {
                if (v.quantity > 0) {
                  variantAddons[addon.id].totalBase +=
                    (Number(v.variant_price) || 0) * v.quantity
                  variantAddons[addon.id].totalQty += v.quantity
                }
              })
            } else {
              variantAddons[addon.id].totalBase +=
                (Number(addon.price) || 0) * (addon.quantity || 0)
              variantAddons[addon.id].totalQty += addon.quantity || 0
            }
          })
          Object.values(variantAddons).forEach((addon) => {
            if (addon.isAdded && addon.addon_status === 'onsale') {
              const addonGross = addon.totalBase
              let a_tax_options = addon.tax_options || []
              if (typeof a_tax_options === 'string') {
                try {
                  a_tax_options = JSON.parse(a_tax_options)
                } catch {
                  a_tax_options = []
                }
              }
              const a_relevantTaxes = stateIsSame
                ? a_tax_options.filter((t) =>
                    ['CGST', 'SGST'].includes(t.tax_name)
                  )
                : a_tax_options.filter((t) => t.tax_name === 'IGST')
              const a_rate =
                a_relevantTaxes.reduce(
                  (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                  0
                ) / 100
              const a_tax_type = addon.tax_type || 'No Tax'
              let addonBaseForAmount = Math.round(addonGross)
              let a_tax_total = 0
              if (a_tax_type === 'Including Tax') {
                let a_taxes = a_relevantTaxes.map((t) => {
                  const tax_percentage =
                    Number.parseFloat(t.tax_percentage) || 0
                  const frac = tax_percentage / 100 / (1 + a_rate)
                  const tax_amount = Math.round(addonGross * frac)
                  return tax_amount
                })
                a_tax_total = a_taxes.reduce((sum, amt) => sum + amt, 0)
                addonBaseForAmount = addonGross - a_tax_total
              } else if (a_tax_type === 'Excluding Tax') {
                a_tax_total = Math.round(addonBaseForAmount * a_rate)
              }
              totalAddonsAmount += addonBaseForAmount + a_tax_total
            }
          })

          const guestData = attendee.guest_data || []
          guestData.forEach((guest) => {
            const guestPrice = Number(ticket.guestPrice) || 0
            let g_tax_options = ticket.guest_details?.tax_options || []
            if (typeof g_tax_options === 'string') {
              try {
                g_tax_options = JSON.parse(g_tax_options)
              } catch {
                g_tax_options = []
              }
            }
            const g_relevantTaxes = stateIsSame
              ? g_tax_options.filter((t) =>
                  ['CGST', 'SGST'].includes(t.tax_name)
                )
              : g_tax_options.filter((t) => t.tax_name === 'IGST')
            const g_rate =
              g_relevantTaxes.reduce(
                (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                0
              ) / 100
            const g_tax_type = ticket.guest_details?.tax_type || 'No Tax'
            let guestBase = Math.round(guestPrice)
            let guest_tax = 0
            if (g_tax_type === 'Including Tax') {
              let g_taxes = g_relevantTaxes.map((t) => {
                const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
                const frac = tax_percentage / 100 / (1 + g_rate)
                const tax_amount = Math.round(guestPrice * frac)
                return tax_amount
              })
              guest_tax = g_taxes.reduce((sum, amt) => sum + amt, 0)
              guestBase = guestPrice - guest_tax
            }
            totalGuestAmount += guestBase

            let guest_add_ons = guest.add_ons || []
            if (typeof guest_add_ons === 'string') {
              try {
                guest_add_ons = JSON.parse(guest_add_ons)
              } catch {
                guest_add_ons = []
              }
            }
            // Group for guest variants
            const guestVariantAddons = {}
            guest_add_ons.forEach((addon) => {
              if (!guestVariantAddons[addon.id]) {
                guestVariantAddons[addon.id] = {
                  ...addon,
                  totalBase: 0,
                  totalQty: 0,
                }
              }
              if (addon.addons_type === 'variant' && addon.selectedVariants) {
                addon.selectedVariants.forEach((v) => {
                  if (v.quantity > 0) {
                    guestVariantAddons[addon.id].totalBase +=
                      (Number(v.variant_price) || 0) * v.quantity
                    guestVariantAddons[addon.id].totalQty += v.quantity
                  }
                })
              } else {
                guestVariantAddons[addon.id].totalBase +=
                  (Number(addon.price) || 0) * (addon.quantity || 0)
                guestVariantAddons[addon.id].totalQty += addon.quantity || 0
              }
            })
            Object.values(guestVariantAddons).forEach((addon) => {
              if (addon.isAdded && addon.addon_status === 'onsale') {
                const addonGross = addon.totalBase
                let a_tax_options = addon.tax_options || []
                if (typeof a_tax_options === 'string') {
                  try {
                    a_tax_options = JSON.parse(a_tax_options)
                  } catch {
                    a_tax_options = []
                  }
                }
                const a_relevantTaxes = stateIsSame
                  ? a_tax_options.filter((t) =>
                      ['CGST', 'SGST'].includes(t.tax_name)
                    )
                  : a_tax_options.filter((t) => t.tax_name === 'IGST')
                const a_rate =
                  a_relevantTaxes.reduce(
                    (sum, t) =>
                      sum + (Number.parseFloat(t.tax_percentage) || 0),
                    0
                  ) / 100
                const a_tax_type = addon.tax_type || 'No Tax'
                let addonBaseForAmount = Math.round(addonGross)
                let a_tax_total = 0
                if (a_tax_type === 'Including Tax') {
                  let a_taxes = a_relevantTaxes.map((t) => {
                    const tax_percentage =
                      Number.parseFloat(t.tax_percentage) || 0
                    const frac = tax_percentage / 100 / (1 + a_rate)
                    const tax_amount = Math.round(addonGross * frac)
                    return tax_amount
                  })
                  a_tax_total = a_taxes.reduce((sum, amt) => sum + amt, 0)
                  addonBaseForAmount = addonGross - a_tax_total
                } else if (a_tax_type === 'Excluding Tax') {
                  a_tax_total = Math.round(addonBaseForAmount * a_rate)
                }
                totalAddonsAmount += addonBaseForAmount + a_tax_total
              }
            })
          })
        })
      }
    })

    const totalBaseAmount =
      totalTicketAmount + totalGuestAmount + totalAddonsAmount
    const totalTaxAmount = pricingData.tax
    const discount = couponApplied
      ? Math.round((totalBaseAmount * pricingData.discount) / 100)
      : 0
    const totalPaymentAmount = Math.round(totalBaseAmount + totalTaxAmount - discount)

    const ticketsMap = new Map()

    attendeeData.tickets &&
      attendeeData.tickets.forEach((ticketData) => {
        const ticket = selectedTickets.find(
          (t) => t.id.toString() === ticketData.ticket_id.toString()
        )
        if (!ticket) return

        ticketData.attendee_data.forEach((attendee, attendeeIndex) => {
          const ticketPrice = Number(ticket.price) || 0
          let tax_options = ticket.tax_options || []
          if (typeof tax_options === 'string') {
            try {
              tax_options = JSON.parse(tax_options)
            } catch {
              tax_options = []
            }
          }
          const relevantTaxes = stateIsSame
            ? tax_options.filter((t) => ['CGST', 'SGST'].includes(t.tax_name))
            : tax_options.filter((t) => t.tax_name === 'IGST')
          const rate =
            relevantTaxes.reduce(
              (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
              0
            ) / 100
          let ticket_amount = Math.round(ticketPrice)
          let ticket_tax = 0
          if (ticket.category !== 'Free' && ticket.tax_type !== 'No Tax') {
            if (ticket.tax_type === 'Excluding Tax') {
              ticket_tax = Math.round(ticketPrice * rate)
              ticket_amount = Math.round(ticketPrice)
            } else if (ticket.tax_type === 'Including Tax') {
              let item_taxes = relevantTaxes.map((t) => {
                const tax_percentage = Number.parseFloat(t.tax_percentage) || 0
                const frac = tax_percentage / 100 / (1 + rate)
                const tax_amount = Math.round(ticketPrice * frac)
                return tax_amount
              })
              ticket_tax = item_taxes.reduce((sum, amt) => sum + amt, 0)
              ticket_amount = ticketPrice - ticket_tax
            }
          }

          let add_ons_data = attendee.add_ons_data || attendee.add_ons || []
          if (typeof add_ons_data === 'string') {
            try {
              add_ons_data = JSON.parse(add_ons_data)
            } catch {
              add_ons_data = []
            }
          }
          // Group for add_on_amount
          const variantAddons = {}
          add_ons_data.forEach((addon) => {
            if (!variantAddons[addon.id]) {
              variantAddons[addon.id] = { ...addon, totalBase: 0, totalQty: 0 }
            }
            if (addon.addons_type === 'variant' && addon.selectedVariants) {
              addon.selectedVariants.forEach((v) => {
                if (v.quantity > 0) {
                  variantAddons[addon.id].totalBase +=
                    (Number(v.variant_price) || 0) * v.quantity
                  variantAddons[addon.id].totalQty += v.quantity
                }
              })
            } else {
              variantAddons[addon.id].totalBase +=
                (Number(addon.price) || 0) * (addon.quantity || 0)
              variantAddons[addon.id].totalQty += addon.quantity || 0
            }
          })
          let add_on_tax = 0
          const add_on_amount = Object.values(variantAddons).reduce(
            (sum, addon) => {
              if (addon.isAdded && addon.addon_status === 'onsale') {
                const addonGross = addon.totalBase
                let a_tax_options = addon.tax_options || []
                if (typeof a_tax_options === 'string') {
                  try {
                    a_tax_options = JSON.parse(a_tax_options)
                  } catch {
                    a_tax_options = []
                  }
                }
                const a_relevantTaxes = stateIsSame
                  ? a_tax_options.filter((t) =>
                      ['CGST', 'SGST'].includes(t.tax_name)
                    )
                  : a_tax_options.filter((t) => t.tax_name === 'IGST')
                const a_rate =
                  a_relevantTaxes.reduce(
                    (sum, t) =>
                      sum + (Number.parseFloat(t.tax_percentage) || 0),
                    0
                  ) / 100
                const a_tax_type = addon.tax_type || 'No Tax'
                let addonBaseForAmount = Math.round(addonGross)
                let a_tax_total = 0
                if (a_tax_type === 'Including Tax') {
                  let a_taxes = a_relevantTaxes.map((t) => {
                    const tax_percentage =
                      Number.parseFloat(t.tax_percentage) || 0
                    const frac = tax_percentage / 100 / (1 + a_rate)
                    const tax_amount = Math.round(addonGross * frac)
                    return tax_amount
                  })
                  a_tax_total = a_taxes.reduce((sum, amt) => sum + amt, 0)
                  addonBaseForAmount = addonGross - a_tax_total
                } else if (a_tax_type === 'Excluding Tax') {
                  a_tax_total = Math.round(addonBaseForAmount * a_rate)
                }
                add_on_tax += a_tax_total
                return sum + addonBaseForAmount
              }
              return sum
            },
            0
          )

          const attendeeEntry = {
            form_id: attendee.form_id,
            form_data: attendee.form_data,
            guest_data: [],
            first_name: attendee.first_name,
            last_name: attendee.last_name,
            email: attendee.email,
            add_ons: add_ons_data,
            actual_payment_amount: (
              ticket_amount +
              ticket_tax +
              add_on_amount +
              add_on_tax
            ).toString(),
            add_on_amount: (add_on_amount + add_on_tax).toString(),
            ticket_amount: ticket_amount.toString(),
            ticket_taxname:
              ticket.tax_type !== 'No Tax'
                ? eventConfig?.tax_name || 'SGST'
                : '',
            ticket_taxpercentage: Math.round(rate * 100),
            ticket_amount_with_tax: (ticket_amount + ticket_tax).toString(),
            instance_type: attendee.instance_type || 'main',
            instance_index: attendee.instance_index || 0,
          }

          const guestData = attendee.guest_data || []
          guestData.forEach((guest, guestIndex) => {
            const guestPrice = Number(ticket.guestPrice) || 0
            let g_tax_options = ticket.guest_details?.tax_options || []
            if (typeof g_tax_options === 'string') {
              try {
                g_tax_options = JSON.parse(g_tax_options)
              } catch {
                g_tax_options = []
              }
            }
            const g_relevantTaxes = stateIsSame
              ? g_tax_options.filter((t) =>
                  ['CGST', 'SGST'].includes(t.tax_name)
                )
              : g_tax_options.filter((t) => t.tax_name === 'IGST')
            const g_rate =
              g_relevantTaxes.reduce(
                (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
                0
              ) / 100
            const g_tax_type = ticket.guest_details?.tax_type || 'No Tax'
            let guest_amount = Math.round(guestPrice)
            let guest_tax = 0
            if (g_tax_type !== 'No Tax') {
              if (g_tax_type === 'Excluding Tax') {
                guest_tax = Math.round(guestPrice * g_rate)
                guest_amount = Math.round(guestPrice)
              } else if (g_tax_type === 'Including Tax') {
                let g_taxes = g_relevantTaxes.map((t) => {
                  const tax_percentage =
                    Number.parseFloat(t.tax_percentage) || 0
                  const frac = tax_percentage / 100 / (1 + g_rate)
                  const tax_amount = Math.round(guestPrice * frac)
                  return tax_amount
                })
                guest_tax = g_taxes.reduce((sum, amt) => sum + amt, 0)
                guest_amount = guestPrice - guest_tax
              }
            }

            let guest_add_ons = guest.add_ons || []
            if (typeof guest_add_ons === 'string') {
              try {
                guest_add_ons = JSON.parse(guest_add_ons)
              } catch {
                guest_add_ons = []
              }
            }
            // Group for guest_addon_amount
            const guestVariantAddons = {}
            guest_add_ons.forEach((addon) => {
              if (!guestVariantAddons[addon.id]) {
                guestVariantAddons[addon.id] = {
                  ...addon,
                  totalBase: 0,
                  totalQty: 0,
                }
              }
              if (addon.addons_type === 'variant' && addon.selectedVariants) {
                addon.selectedVariants.forEach((v) => {
                  if (v.quantity > 0) {
                    guestVariantAddons[addon.id].totalBase +=
                      (Number(v.variant_price) || 0) * v.quantity
                    guestVariantAddons[addon.id].totalQty += v.quantity
                  }
                })
              } else {
                guestVariantAddons[addon.id].totalBase +=
                  (Number(addon.price) || 0) * (addon.quantity || 0)
                guestVariantAddons[addon.id].totalQty += addon.quantity || 0
              }
            })
            let guest_addon_tax = 0
            const guest_addon_amount = Object.values(guestVariantAddons).reduce(
              (sum, addon) => {
                if (addon.isAdded && addon.addon_status === 'onsale') {
                  const addonGross = addon.totalBase
                  let a_tax_options = addon.tax_options || []
                  if (typeof a_tax_options === 'string') {
                    try {
                      a_tax_options = JSON.parse(a_tax_options)
                    } catch {
                      a_tax_options = []
                    }
                  }
                  const a_relevantTaxes = stateIsSame
                    ? a_tax_options.filter((t) =>
                        ['CGST', 'SGST'].includes(t.tax_name)
                      )
                    : a_tax_options.filter((t) => t.tax_name === 'IGST')
                  const a_rate =
                    a_relevantTaxes.reduce(
                      (sum, t) =>
                        sum + (Number.parseFloat(t.tax_percentage) || 0),
                      0
                    ) / 100
                  const a_tax_type = addon.tax_type || 'No Tax'
                  let addonBaseForAmount = Math.round(addonGross)
                  let a_tax_total = 0
                  if (a_tax_type === 'Including Tax') {
                    let a_taxes = a_relevantTaxes.map((t) => {
                      const tax_percentage =
                        Number.parseFloat(t.tax_percentage) || 0
                      const frac = tax_percentage / 100 / (1 + a_rate)
                      const tax_amount = Math.round(addonGross * frac)
                      return tax_amount
                    })
                    a_tax_total = a_taxes.reduce((sum, amt) => sum + amt, 0)
                    addonBaseForAmount = addonGross - a_tax_total
                  } else if (a_tax_type === 'Excluding Tax') {
                    a_tax_total = Math.round(addonBaseForAmount * a_rate)
                  }
                  guest_addon_tax += a_tax_total
                  return sum + addonBaseForAmount
                }
                return sum
              },
              0
            )

            const guestEntry = {
              form_id: attendee.form_id,
              form_data: guest.custom_fields || [],
              guest_data: [],
              first_name:
                guest.custom_fields?.find((f) => f.name === 'first_name')
                  ?.value || '',
              last_name:
                guest.custom_fields?.find((f) => f.name === 'last_name')
                  ?.value || '',
              email:
                guest.custom_fields?.find((f) => f.name === 'email_address')
                  ?.value || '',
              add_ons: guest_add_ons,
              actual_payment_amount: (
                guest_amount +
                guest_tax +
                guest_addon_amount +
                guest_addon_tax
              ).toString(),
              add_on_amount: (guest_addon_amount + guest_addon_tax).toString(),
              ticket_amount: guest_amount.toString(),
              ticket_taxname:
                g_tax_type !== 'No Tax' ? eventConfig?.tax_name || 'SGST' : '',
              ticket_taxpercentage: Math.round(g_rate * 100),
              ticket_amount_with_tax: (guest_amount + guest_tax).toString(),
              instance_type: 'guest',
              instance_index: guestIndex,
            }

            attendeeEntry.guest_data.push(guestEntry)
          })

          if (!ticketsMap.has(ticketData.ticket_id)) {
            ticketsMap.set(ticketData.ticket_id, {
              ticket_id: Number.parseInt(ticketData.ticket_id),
              attendee_data: [],
            })
          }

          ticketsMap.get(ticketData.ticket_id).attendee_data.push(attendeeEntry)
        })
      })

    const ticketsData = Array.from(ticketsMap.values())

    let buyerDetails = {
      buyer_type: 'individual',
      custom_fields: [],
    }

    if (selectedTickets.length > 1 && buyerData) {
      buyerDetails = {
        buyer_type: 'individual',
        custom_fields: buyerData.custom_fields || [],
      }
    } else if (
      attendeeData &&
      attendeeData.tickets &&
      attendeeData.tickets.length > 0
    ) {
      const firstAttendee =
        attendeeData.tickets[0] &&
        attendeeData.tickets[0].attendee_data &&
        attendeeData.tickets[0].attendee_data[0]
      if (firstAttendee) {
        buyerDetails = {
          buyer_type: 'individual',
          custom_fields: [
            {
              id: 'field-buyer-firstname',
              type: 'text',
              label: 'First Name',
              name: 'first_name',
              value: firstAttendee.first_name || '',
            },
            {
              id: 'field-buyer-lastname',
              type: 'text',
              label: 'Last Name',
              name: 'last_name',
              value: firstAttendee.last_name || '',
            },
            {
              id: 'field-buyer-email',
              type: 'email',
              label: 'Email Address',
              name: 'email_address',
              value: firstAttendee.email || '',
            },
          ],
        }
      }
    }

    const totalAttendees = selectedTickets.reduce((sum, ticket) => {
      return sum + (ticket.ticketQuantity || 1) + (ticket.guestCount || 0)
    }, 0)

    const finalPayload = {
      event_id:
        (eventData && eventData.event && eventData.event.id) ||
        (eventData && eventData.id) ||
        1,
      tickets: ticketsData,
      buyer_details: buyerDetails,
      ticket_count: totalAttendees,
      payment_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      payment_method: 'Razorpay',
      coupon_applied_amount: discount.toString(),
      coupon_applied_percentage: couponApplied ? pricingData.discount : 0,
      payment_received: totalPaymentAmount.toString(),
      additional_notes: couponApplied ? `Coupon applied: ${couponCode}` : '',
      total_amount: pricingData.total.toString(), // Use the calculated total from calculatePricing
      currency: (selectedTickets[0] && selectedTickets[0].currency) || 'INR',
      total_addons_amount: totalAddonsAmount.toString(),
      total_tax_amount: totalTaxAmount.toString(),
      total_ticket_amount: (totalTicketAmount + totalGuestAmount).toString(),
      coupon_code: couponApplied ? couponCode : '',
      coupon_discount_percentage: couponApplied ? pricingData.discount : 0,
      coupon_discount_amount: discount.toString(),
    }

    return finalPayload
  }

  const handleProceedToPayment = () => {
    const paymentData = preparePaymentData()
    console.log('Final Payment Data:', paymentData)

    if (onProceedToPayment) {
      onProceedToPayment(paymentData)
    }
  }

  const { subtotal, tax, total, discount, taxName, tax_breakdown } =
    calculatePricing()
  const taxBreakdownItems = getTaxBreakdownItems()

  return (
    <>
      <div className="order-summary-header">
        <div className="order-header-content">
          <h1 className="order-header-title">Order Summary</h1>
          <div className="order-header-details">
            {/* <div className="order-header-item">
              <Calendar className="header-icon" />
              <span>
                {eventData
                  ? `${formatDate((eventData.event && eventData.event.start_date) || eventData.start_date)} - ${formatDate(
                      (eventData.event && eventData.event.end_date) || eventData.end_date,
                    )}`
                  : "Loading..."}
              </span>
            </div> */}
            {/* <div className="order-header-separator"></div> */}
            {/* <div className="order-header-item">
              <MapPin className="header-icon" />
              <span>
                {(eventData && eventData.event && eventData.event.venue_city) ||
                  (eventData && eventData.venue_city) ||
                  "Location"}
              </span>
            </div> */}
          </div>
        </div>
      </div>

      <div className="order-summary-content">
        <div className="simple-breadcrumb">
          <span className="breadcrumb-step completed">Tickets</span>
          <ChevronRight className="breadcrumb-arrow" />
          {selectedTickets.length > 1 && (
            <>
              <span className="breadcrumb-step completed">Buyer Details</span>
              <ChevronRight className="breadcrumb-arrow" />
            </>
          )}
          <span className="breadcrumb-step completed">Attendee Details</span>
          <ChevronRight className="breadcrumb-arrow" />
          <span className="breadcrumb-step active">Order Summary</span>
          <ChevronRight className="breadcrumb-arrow" />
          <span className="breadcrumb-step">Payment</span>
        </div>
        {console.log(selectedTickets, 'selectedTickets')}
        <div className="clean-tickets-container">
          {selectedTickets.map((ticket, index) => {
            const isExpanded = expandedTickets[ticket.id]
            const ticketNumber = index + 1
            const attendeeCount =
              (ticket.ticketQuantity || 1) + (ticket.guestCount || 0)
            const ticketAttendeeData = attendeeData.tickets
              ? attendeeData.tickets.find(
                  (data) => data.ticket_id.toString() === ticket.id.toString()
                )
              : null

            // Collect all attendees and guests for unified rendering
            const allInstances = []

            // Main attendees
            if (ticketAttendeeData && ticketAttendeeData.attendee_data) {
              ticketAttendeeData.attendee_data.forEach(
                (attendee, attendeeIndex) => {
                  if (attendee.instance_type !== 'guest') {
                    allInstances.push({
                      ...attendee,
                      isGuest: false,
                      index: attendeeIndex,
                    })
                  }
                }
              )
            }

            // Guests - fallback to placeholders if not in data
            const guestData =
              ticketAttendeeData?.attendee_data?.[0]?.guest_data || []
            const actualGuestCount = guestData.length
            const expectedGuestCount = ticket.guestCount || 0
            if (expectedGuestCount > 0) {
              for (let gIndex = 0; gIndex < expectedGuestCount; gIndex++) {
                const guest = guestData[gIndex] || {
                  first_name: `Accompanying Person ${gIndex + 1}`,
                  last_name: '',
                  email: '',
                  add_ons: [],
                  instance_type: 'guest',
                }
                allInstances.push({ ...guest, isGuest: true, index: gIndex })
              }
            }

            return (
              <div key={ticket.id} className="clean-ticket-card">
                <div className="clean-ticket-main">
                  <div className="ticket-main-info">
                    <h3 className="clean-ticket-title">
                      Ticket #{ticketNumber}: {ticket.title}
                    </h3>
                    <p className="clean-ticket-attendees">
                      {attendeeCount} attendee{attendeeCount !== 1 ? 's' : ''}
                    </p>
                  </div>
                  <button
                    className="clean-expand-btn"
                    onClick={() => toggleTicketExpansion(ticket.id)}
                  >
                    {isExpanded ? (
                      <ChevronUp className="expand-icon" />
                    ) : (
                      <ChevronDown className="expand-icon" />
                    )}
                  </button>
                </div>
                {isExpanded && (
                  <div className="clean-ticket-expanded">
                    <div className="attendee-list">
                      {allInstances.map((instance, instanceIndex) => {
                        const { isGuest, index: origIndex } = instance
                        let totalPerPersonPrice = 0
                        let totalPerPersonTax = 0
                        let addOnRows = []

                        // Determine base price, tax options, tax type
                        let basePrice = 0
                        let tax_options = []
                        let tax_type = 'No Tax'
                        if (isGuest) {
                          basePrice = Number(ticket.guestPrice) || 0
                          tax_options = ticket.guest_details?.tax_options || []
                          tax_type = ticket.guest_details?.tax_type || 'No Tax'
                        } else {
                          basePrice = Number(ticket.price) || 0
                          tax_options = ticket.tax_options || []
                          tax_type = ticket.tax_type || 'No Tax'
                        }

                        // Parse tax_options if string
                        if (typeof tax_options === 'string') {
                          try {
                            tax_options = JSON.parse(tax_options)
                          } catch {
                            tax_options = []
                          }
                        }

                        const relevantTaxes = stateIsSame
                          ? tax_options.filter((t) =>
                              ['CGST', 'SGST'].includes(t.tax_name)
                            )
                          : tax_options.filter((t) => t.tax_name === 'IGST')
                        const rate =
                          relevantTaxes.reduce(
                            (sum, t) =>
                              sum + (Number.parseFloat(t.tax_percentage) || 0),
                            0
                          ) / 100

                        // Calculate base item price and tax
                        let itemPrice = Math.round(basePrice)
                        let taxAmount = 0
                        if (tax_type !== 'No Tax' && basePrice > 0) {
                          if (tax_type === 'Excluding Tax') {
                            taxAmount = Math.round(basePrice * rate)
                          } else if (tax_type === 'Including Tax') {
                            let item_taxes = relevantTaxes.map((t) => {
                              const tax_percentage =
                                Number.parseFloat(t.tax_percentage) || 0
                              const frac = tax_percentage / 100 / (1 + rate)
                              const tax_amount = Math.round(basePrice * frac)
                              return tax_amount
                            })
                            taxAmount = item_taxes.reduce(
                              (sum, amt) => sum + amt,
                              0
                            )
                            itemPrice = basePrice - taxAmount
                          }
                        }
                        totalPerPersonPrice += itemPrice
                        totalPerPersonTax += taxAmount

                        // Handle add-ons
                        let add_ons_data = isGuest
                          ? instance.add_ons || []
                          : instance.add_ons_data || instance.add_ons || []
                        if (typeof add_ons_data === 'string') {
                          try {
                            add_ons_data = JSON.parse(add_ons_data)
                          } catch {
                            add_ons_data = []
                          }
                        }

                        // Group variants
                        const variantAddons = {}
                        add_ons_data.forEach((addon) => {
                          if (!variantAddons[addon.id]) {
                            variantAddons[addon.id] = {
                              ...addon,
                              totalBase: 0,
                              totalQty: 0,
                              variantNames: [],
                            }
                          }
                          if (
                            addon.addons_type === 'variant' &&
                            addon.selectedVariants
                          ) {
                            addon.selectedVariants.forEach((v) => {
                              if (v.quantity > 0) {
                                variantAddons[addon.id].totalBase +=
                                  (Number(v.variant_price) || 0) * v.quantity
                                variantAddons[addon.id].totalQty += v.quantity
                                if (
                                  !variantAddons[
                                    addon.id
                                  ].variantNames.includes(v.variant_name)
                                ) {
                                  variantAddons[addon.id].variantNames.push(
                                    v.variant_name
                                  )
                                }
                              }
                            })
                          } else {
                            variantAddons[addon.id].totalBase +=
                              (Number(addon.price) || 0) * (addon.quantity || 0)
                            variantAddons[addon.id].totalQty +=
                              addon.quantity || 0
                          }
                        })

                        Object.values(variantAddons).forEach((addon) => {
                          if (
                            addon.isAdded &&
                            addon.addon_status === 'onsale'
                          ) {
                            const addonGross = addon.totalBase
                            const addonQuantity = addon.totalQty
                            if (addonGross === 0) return
                            let a_tax_options = addon.tax_options || []
                            if (typeof a_tax_options === 'string') {
                              try {
                                a_tax_options = JSON.parse(a_tax_options)
                              } catch {
                                a_tax_options = []
                              }
                            }
                            const a_relevantTaxes = stateIsSame
                              ? a_tax_options.filter((t) =>
                                  ['CGST', 'SGST'].includes(t.tax_name)
                                )
                              : a_tax_options.filter(
                                  (t) => t.tax_name === 'IGST'
                                )
                            const a_rate =
                              a_relevantTaxes.reduce(
                                (sum, t) =>
                                  sum +
                                  (Number.parseFloat(t.tax_percentage) || 0),
                                0
                              ) / 100
                            const a_tax_type = addon.tax_type || 'No Tax'
                            let addonNet = 0
                            let addonTax = 0
                            if (a_tax_type !== 'No Tax') {
                              if (a_tax_type === 'Excluding Tax') {
                                addonTax = Math.round(addonGross * a_rate)
                                addonNet = Math.round(addonGross)
                              } else if (a_tax_type === 'Including Tax') {
                                let a_taxes = a_relevantTaxes.map((t) => {
                                  const tax_percentage =
                                    Number.parseFloat(t.tax_percentage) || 0
                                  const frac =
                                    tax_percentage / 100 / (1 + a_rate)
                                  const tax_amount = Math.round(
                                    addonGross * frac
                                  )
                                  return tax_amount
                                })
                                addonTax = a_taxes.reduce(
                                  (sum, amt) => sum + amt,
                                  0
                                )
                                addonNet = addonGross - addonTax
                              }
                            } else {
                              addonNet = Math.round(addonGross)
                            }
                            totalPerPersonPrice += addonNet
                            totalPerPersonTax += addonTax

                            const variantNamesStr =
                              addon.variantNames.length > 0
                                ? ` (${addon.variantNames.join(', ')})`
                                : ''
                            const addonDisplayName = `${addonQuantity} x ${addon.add_on_name}${variantNamesStr}`

                            addOnRows.push(
                              <div
                                key={`addon-${instanceIndex}-${addon.id}`}
                                className="clean-attendee-subrow"
                              >
                                <div className="attendee-info sub-item">
                                  {addonDisplayName}
                                </div>
                                <div className="attendee-actions sub-price">
                                  {`${ticket.currency || 'INR'} ${(
                                    addonNet + addonTax
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}`}
                                </div>
                              </div>
                            )
                          }
                        })

                        totalPerPersonPrice = Math.round(totalPerPersonPrice)
                        totalPerPersonTax = Math.round(totalPerPersonTax)

                        // Display name
                        const displayName = instance.first_name
                          ? `${instance.first_name} ${instance.last_name || ''}`
                          : isGuest
                          ? `Accompanying Person ${origIndex + 1}`
                          : 'Attendee'

                        const displayIndex = instanceIndex + 1

                        return (
                          <div
                            key={`${
                              isGuest ? 'guest' : 'attendee'
                            }-${instanceIndex}`}
                          >
                            <div className="clean-attendee-row">
                              <div className="attendee-info">
                                <span className="attendee-num">
                                  {displayIndex}.
                                </span>
                                <span className="attendee-name">
                                  {displayName}
                                </span>
                                {instance.email && (
                                  <span className="attendee-email">
                                    ({instance.email})
                                  </span>
                                )}
                              </div>
                              <div className="attendee-actions">
                                <span className="attendee-price">
                                  {`${ticket.currency || 'INR'} ${(
                                    totalPerPersonPrice + totalPerPersonTax
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}`}
                                </span>
                              </div>
                            </div>
                            {addOnRows}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
        {total !== 0 && isCouponAvailable && (
          <div className="coupon-section">
            <div className="coupon-input-group">
              <input
                type="text"
                className="form-input coupon-input"
                placeholder="Enter coupon code"
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value)
                  if (couponApplied) {
                    setCouponApplied(false)
                    setCouponDiscount(0)
                    setCouponError('')
                  }
                }}
              />
              <button
                className="btn btn-primary coupon-apply-btn"
                onClick={handleApplyCoupon}
                disabled={!couponCode || isCouponLoading}
              >
                {isCouponLoading ? 'Applying...' : 'Apply'}
              </button>
            </div>
            {couponError && <p className="coupon-error">{couponError}</p>}
            {couponApplied && (
              <p className="coupon-success">
                Coupon applied: {couponCode} ({couponDiscount}% off)
              </p>
            )}
          </div>
        )}
        <div className="clean-summary-section">
          {tax_breakdown.map((item, index) => (
            <div key={index} className="summary-item">
              <div className="summary-row">
                <span className="summary-label">{item.name}</span>
                <span className="summary-value">
                  {(selectedTickets[0] && selectedTickets[0].currency) || 'INR'}  {' '}
                  {item.base_price.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </span>
              </div>
              {item.taxes.map((tax, taxIndex) => (
                <div key={taxIndex} className="summary-row">
                  <span className="summary-sublabel">
                    {tax.tax_name} ({tax.tax_percentage}%)
                  </span>
                 <span className="summary-subvalue">
  {(selectedTickets[0] && selectedTickets[0].currency) || 'INR'}{' '}
  {tax.tax_amount.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}
</span>
                </div>
              ))}
              {couponApplied && (
                <div className="summary-row">
                  <span className="summary-sublabel">
                    Coupon Discount ({couponCode})
                  </span>
                  <span className="summary-subvalue discount">
                    -{' '}
                    {(selectedTickets[0] && selectedTickets[0].currency) ||
                      'INR'}{' '}
                    {Math.round(
                      (item.base_price * couponDiscount) / 100
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
              )}
            </div>
          ))}
          <div className="summary-row">
            <span className="summary-label">Subtotal</span>
            <span className="summary-value">
              {(selectedTickets[0] && selectedTickets[0].currency) || 'INR'}{' '}
              {subtotal.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </span>
          </div>
          <div className="summary-row">
            <span className="summary-label">
              Total Tax
              <button
                className="tax-breakdown-btn"
                onClick={() => setShowTaxBreakdown(true)}
              >
                Tax Breakdown
              </button>
            </span>
            <span className="summary-value">
              {(selectedTickets[0] && selectedTickets[0].currency) || 'INR'}{' '}
              {tax.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </span>
          </div>
          {couponApplied && (
            <div className="summary-row">
              <span className="summary-label">
                Total Coupon Discount ({couponCode})
              </span>
              <span className="summary-value discount">
                - {(selectedTickets[0] && selectedTickets[0].currency) || 'INR'}{' '}
                {discount.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </span>
            </div>
          )}
          <div className="summary-row grand-total">
            <span className="summary-label">Grand Total</span>
            <span className="summary-value total-amount">
              {(selectedTickets[0] && selectedTickets[0].currency) || 'INR'}{' '}
              {total.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </span>
          </div>
        </div>
      </div>

      <div className="clean-bottom-actions">
        <div>
          <button className="btn btn-outline mr-2" onClick={onBack}>
            Back
          </button>
          <button className="btn btn-primary" onClick={handleProceedToPayment}>
            {total === 0 ? 'Confirm Register' : 'Make Payment'}
            {total > 0 && <ChevronRight className="payment-arrow" />}
          </button>
        </div>
      </div>

      {showTaxBreakdown && (
        <div
          className="tax-modal-overlay"
          onClick={() => setShowTaxBreakdown(false)}
        >
          <div
            className="tax-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tax-modal-header">
              <h3 className="tax-modal-title">Tax Breakdown</h3>
              <button
                className="tax-modal-close"
                onClick={() => setShowTaxBreakdown(false)}
              >
                <X className="close-icon" />
              </button>
            </div>

            <div className="tax-modal-body">
              <div className="tax-breakdown-table">
                <div className="tax-table-header">
                  <div className="tax-header-item">Items</div>
                  <div className="tax-header-tax">Tax</div>
                  <div className="tax-header-price">Price</div>
                </div>

                <div className="tax-table-body">
                  {taxBreakdownItems.map((item, index) => (
                    <div key={index} className="tax-table-row">
                      <div className="tax-item-name">{item.name}</div>
                      <div className="tax-item-tax">
                        {(selectedTickets[0] && selectedTickets[0].currency) ||
                          'INR'}{' '}
                        {item.tax.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                      </div>
                      <div className="tax-item-price">
                        {(selectedTickets[0] && selectedTickets[0].currency) ||
                          'INR'}{' '}
                        {item.basePrice.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="tax-table-footer">
                  <div className="tax-total-row">
                    <div className="tax-total-label">Total Tax</div>
                    <div className="tax-total-amount">
                      {(selectedTickets[0] && selectedTickets[0].currency) ||
                        'INR'}{' '}
                      {tax.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default OrderSummary
